import { toast } from 'react-toastify';

// Configurez si nécessaire, sinon importez le style dans votre fichier principal (ex: App.jsx)
// import 'react-toastify/dist/ReactToastify.css';

export const toastSuccess = (message) => {
    toast.success(message);
};

export const toastError = (message) => {
    toast.error(message);
};

export const toastInfo = (message) => {
    toast.info(message);
};